/**
 * Read-more truncator
 * ---------------------------------
 * 1.  Finds every element that has data-read-more="123" (height in px).
 * 2.  If the element’s scrollHeight > maxHeight, it:
 *        • sets max-height + overflow: hidden
 *        • appends a toggle link
 * 3.  Clicking the link expands/collapses the element and updates the link text.
 *
 *  Works for any text-based element (div, p, rich-text, etc.).
 */
export function initReadMore () {
  /** Utility to create the toggle link */
  function makeToggleLink(initial) {
    const link = document.createElement('a');
    link.href = '#';
    link.textContent = initial ? 'Read more' : 'Read less';
    link.style.display = 'inline-block';
    link.style.color = '#0a4915';
    link.style.fontWeight = '600';
    return link;
  }

  /** Main scan */
  document.querySelectorAll('[data-read-more]').forEach((el) => {
    const maxHeight = parseInt(el.getAttribute('data-read-more'), 10);
    if (isNaN(maxHeight)) return; // skip if attribute malformed

    // Already short enough? leave untouched
    if (el.scrollHeight <= maxHeight) return;

    // Prepare element: hide overflow & store full height
    el.style.maxHeight = maxHeight + 'px';
    el.style.overflow = 'hidden';
    el.dataset.readMoreState = 'collapsed';

    // Insert toggle link after the element
    const toggle = makeToggleLink(true);
    el.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const collapsed = el.dataset.readMoreState === 'collapsed';

      if (collapsed) {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.dataset.readMoreState = 'expanded';
        this.textContent = 'Read less';
      } else {
        el.style.maxHeight = maxHeight + 'px';
        el.dataset.readMoreState = 'collapsed';
        this.textContent = 'Read more';
      }
    });
  });
}